import { pxToRem } from '../../helpers'
import { StyleFn } from '..'

/**
 * List classes used in PopoverMenu, SideNav, ComboBox, etc.
 **/
export const List: StyleFn = ({ color, font, opacity, size }) => {
  const activeBGColor =
    color.type === 'light' ? color.background.interactive.ghost.hover : color.background.interactive.ghostReverse.hover
  const focusStyles = {
    outline: 'none',
    boxShadow: `inset 0px 0px 0px 1px ${color.getModalValues(color.border.focus)}`,
  }

  return {
    root: {
      display: 'block',
      listStyle: 'none',
      minWidth: pxToRem(200),
      margin: 0,
      padding: `${size.spacing[4]} 0`,
      fontSize: font.size.small,
      lineHeight: font.lineheight.medium,
      color: color.type === 'light' ? color.palette.coolgrey[90] : color.palette.white,
    },
    item: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      cursor: 'pointer',
      padding: `${size.spacing[8]} ${size.spacing[16]}`,
      '&:hover, &:active, &[aria-selected=true]': {
        backgroundColor: activeBGColor,
      },
      '&:focus-visible': focusStyles,
    },
    item_selected: {
      fontWeight: font.weight.bold,
      backgroundColor: activeBGColor,
    },
    item_disabled: {
      opacity: opacity.disabled,
      userSelect: 'none',
      pointerEvents: 'none',
    },
    item_quiet: {
      // increase specificity for dark theme
      '$item_quiet&': {
        '&$item_selected': {
          background: 'unset',
          backgroundColor: 'unset',
        },
        '&:hover': { backgroundColor: activeBGColor },
        '&:active': { backgroundColor: activeBGColor },
        '&[aria-selected=true]': {
          backgroundColor: activeBGColor,
        },
      },
    },
    itemText: {
      flex: '1 1 auto',
    },
    itemIcon: {
      flexShrink: 0,
      marginRight: size.spacing[8],
      lineHeight: 1,
      '& svg, & i': {
        fontSize: font.size.medium,
        verticalAlign: 'middle',
      },
    },
  }
}

/** RETRO COMPATIBILITY with "ds-menu-*" classes */
export const Menu = List
